export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday"];
export const DAY_LABELS = { monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday", friday: "Friday" };
export const DAY_COLORS = {
  monday: { bg: "bg-blue-50", header: "bg-blue-600", border: "border-blue-200", text: "text-blue-700", accent: "#2563EB" },
  tuesday: { bg: "bg-rose-50", header: "bg-rose-500", border: "border-rose-200", text: "text-rose-700", accent: "#F43F5E" },
  wednesday: { bg: "bg-slate-50", header: "bg-slate-600", border: "border-slate-200", text: "text-slate-700", accent: "#475569" },
  thursday: { bg: "bg-purple-50", header: "bg-purple-600", border: "border-purple-200", text: "text-purple-700", accent: "#7C3AED" },
  friday: { bg: "bg-emerald-50", header: "bg-emerald-600", border: "border-emerald-200", text: "text-emerald-700", accent: "#059669" },
};

// One consistent color per block, used as a subtle left-border / tint signal on
// schedule cards (replaces the old B1/B2 text tags).
export const BLOCK_COLORS = ["#2563EB", "#16A34A", "#9333EA", "#EA580C", "#0891B2", "#DB2777", "#CA8A04", "#4F46E5"];

/** Resolve a stable color for a block by its number (1-based) or list index. */
export function blockColorFor(blockNumberOrIndex) {
  const n = Number(blockNumberOrIndex);
  const idx = Number.isFinite(n) && n > 0 ? n - 1 : 0;
  return BLOCK_COLORS[idx % BLOCK_COLORS.length];
}

// Progressive alpha per block row so each block gets a slightly different shade of its day-column color.
export const SHADE_ALPHAS = ["0A", "12", "1A", "22", "2A", "32", "3A", "42"];
export function dayShade(accent, idx = 0) {
  return accent + SHADE_ALPHAS[idx % SHADE_ALPHAS.length];
}

export const EMPTY_CLASS = { subject: "", lead_staff_id: "", support_staff_ids: [], student_group: "", student_group_type: "", student_group_key: "", student_ids: [], location: "", notes: "", highlight: false, requires_signup: false, signup_capacity: "" };

/** Normalize a cell value: always return an array of class entries */
export function normCell(val) {
  if (Array.isArray(val)) return val;
  if (val && typeof val === "object" && (val.subject || val.lead_staff_id)) return [val];
  return [];
}

export function getTodayDayKey() {
  const d = new Date().getDay();
  const map = { 1: "monday", 2: "tuesday", 3: "wednesday", 4: "thursday", 5: "friday" };
  return map[d] || null;
}

/** Build display names: preferred/first name only, add last initial if duplicates exist */
export function buildDisplayNames(people, firstNameKey = "first_name", lastNameKey = "last_name", preferredKey = "preferred_name") {
  const getFirst = (p) => (preferredKey && p[preferredKey]) || p[firstNameKey] || "";
  const counts = {};
  people.forEach(p => { const name = getFirst(p).toLowerCase(); counts[name] = (counts[name] || 0) + 1; });
  const lookup = {};
  people.forEach(p => {
    const first = getFirst(p);
    const isDup = counts[first.toLowerCase()] > 1;
    lookup[p.id] = isDup ? `${first} ${(p[lastNameKey] || "")[0] || ""}.` : first;
  });
  return lookup;
}

/** Sort people by preferred/first name alphabetically */
export function sortByPreferredName(people, preferredKey = "preferred_name", firstKey = "first_name") {
  return [...people].sort((a, b) => {
    const na = ((preferredKey && a[preferredKey]) || a[firstKey] || "").toLowerCase();
    const nb = ((preferredKey && b[preferredKey]) || b[firstKey] || "").toLowerCase();
    return na.localeCompare(nb);
  });
}
